import { Backdrop, CircularProgress, useMediaQuery } from '@mui/material';
import { theme } from '../../utils/theme/godzilla_light';
import Applogo from '../../assets/images/onboardPage/hypercept_logo.png'
interface IBackdropComponentProps {
  showBackdrop: boolean;
}

function GradientCircularProgress() {
  return (
    <>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="20%" stopColor="#404144" />
            <stop offset="80%" stopColor="#fff" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={{
        'svg circle': { stroke: 'url(#my_gradient)' }, '& .MuiCircularProgress-circle': {
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }} thickness={5} />
    </>
  );
}

export const BackdropComponent = (props: IBackdropComponentProps) => {
  const { showBackdrop } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down(950))

  return (
    <Backdrop
      sx={{ color: '#000', zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "#fff", display: "flex", flexDirection: "column" }}
      open={showBackdrop}>
      <GradientCircularProgress />
      <img src={Applogo} style={{ height: isMobile ? "25px" : "49px", width: isMobile ? "189px" : "378px", marginTop: "24px" }} alt='astellas-loader-logo' />
    </Backdrop>
  );
}